module.exports = __webpack_public_path__ + "img/Khandevane.195363c.png";